import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const InfoBox = (props) => {
  const { text } = props || {};

  return (
    <div className="info-box-message">
      <InfoOutlinedIcon />
      <span>{text}</span>
    </div>
  );
};

export default InfoBox;
